import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    MultiSelectBox,
    SearchDateBox,
    SearchBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import TaroffOrdersEdit from '../orders/TaroffOrdersEdit';
import TaroffOrdersPeikSetAccepted from '../peik/TaroffOrdersPeikSetAccepted';
import TaroffOrdersPeikSetNotAccepted from '../peik/TaroffOrdersPeikSetNotAccepted';
import TaroffOrdersPeikSetRejected from '../peik/TaroffOrdersPeikSetRejected';
import TaroffOrdersPeikSetDelivered from '../peik/TaroffOrdersPeikSetDelivered';
import TaroffOrdersCopy from '../orders/TaroffOrdersCopy';
import TaroffOrdersDelete from '../orders/TaroffOrdersDelete';
import TaroffOrdersPeikConfirmOrder from '../peik/TaroffOrdersPeikConfirmOrder';
import TaroffOrdersView from '../orders/TaroffOrdersView';
import { postData, API_URL } from '../../Api';

export default function TaroffOrdersPeik(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik/select-data/q-shop-id').then((response) => {
            setFormQShopIdOptions(response.data);
        });
    }, []);
    const [formQStateIdOptions, setFormQStateIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik/select-data/q-state-id').then((response) => {
            setFormQStateIdOptions(response.data);
        });
    }, []);
    const [formQZoneIdOptions, setFormQZoneIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik/select-data/q-zone-id').then((response) => {
            setFormQZoneIdOptions(response.data);
        });
    }, []);
    const [formQPeikIdOptions, setFormQPeikIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik/select-data/q-peik-id').then((response) => {
            setFormQPeikIdOptions(response.data);
        });
    }, []);
    const [formQPaymentMethodIdOptions, setFormQPaymentMethodIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik/select-data/q-payment-method-id').then(
            (response) => {
                setFormQPaymentMethodIdOptions(response.data);
            }
        );
    }, []);
    const [formQShiftIdOptions, setFormQShiftIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik/select-data/q-shift-id').then((response) => {
            setFormQShiftIdOptions(response.data);
        });
    }, []);
    const [formQDeliverTimeIdOptions, setFormQDeliverTimeIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik/select-data/q-deliver-time-id').then(
            (response) => {
                setFormQDeliverTimeIdOptions(response.data);
            }
        );
    }, []);
    const handlecomp1 = () => {
        const queryString = {
            'token': localStorage.getItem('admin_auth_token'),
            'q-id': filterQId,
            'q-shop-code': filterQShopCode,
            'q-shop-id': filterQShopId,
            'q-state-id': filterQStateId,
            'q-zone-id': filterQZoneId,
            'q-peik-id': filterQPeikId,
            'q-payment-method-id': filterQPaymentMethodId,
            'q-title': filterQTitle,
            'q-insert-time-from': filterQInsertTimeFrom,
            'q-insert-time-to': filterQInsertTimeTo,
            'q-shift-id': filterQShiftId,
            'q-deliver-time-id': filterQDeliverTimeId,
            'q-customer-name': filterQCustomerName,
            'q-customer-mobile': filterQCustomerMobile,
            'q-post-barcode': filterQPostBarcode,
            'q-ready-time-from': filterQReadyTimeFrom,
            'q-ready-time-to': filterQReadyTimeTo,
            'q-send-time-from': filterQSendTimeFrom,
            'q-send-time-to': filterQSendTimeTo,
            'q-deliver-time-from': filterQDeliverTimeFrom,
            'q-deliver-time-to': filterQDeliverTimeTo,
            'q-reject-time-from': filterQRejectTimeFrom,
            'q-reject-time-to': filterQRejectTimeTo,
        };
        const url =
            API_URL +
            '/api/panel/page/taroff-orders-peik/export-excel?' +
            new URLSearchParams(queryString).toString();
        window.open(url, '_blank');
    };
    const handlecomp2 = () => {
        applyFilters();
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQId('');
        setFilterQShopCode('');
        setFilterQShopId('');
        setFilterQStateId('');
        setFilterQZoneId('');
        setFilterQPeikId('');
        setFilterQPaymentMethodId('');
        setFilterQTitle('');
        setFilterQInsertTimeFrom('');
        setFilterQInsertTimeTo('');
        setFilterQShiftId('');
        setFilterQDeliverTimeId('');
        setFilterQCustomerName('');
        setFilterQCustomerMobile('');
        setFilterQPostBarcode('');
        setFilterQReadyTimeFrom('');
        setFilterQReadyTimeTo('');
        setFilterQSendTimeFrom('');
        setFilterQSendTimeTo('');
        setFilterQDeliverTimeFrom('');
        setFilterQDeliverTimeTo('');
        setFilterQRejectTimeFrom('');
        setFilterQRejectTimeTo('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQId && (newSearchParams['q-id'] = filterQId);
        filterQShopCode && (newSearchParams['q-shop-code'] = filterQShopCode);
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        filterQStateId && (newSearchParams['q-state-id'] = filterQStateId);
        filterQZoneId && (newSearchParams['q-zone-id'] = filterQZoneId);
        filterQPeikId && (newSearchParams['q-peik-id'] = filterQPeikId);
        filterQPaymentMethodId && (newSearchParams['q-payment-method-id'] = filterQPaymentMethodId);
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        filterQInsertTimeFrom && (newSearchParams['q-insert-time-from'] = filterQInsertTimeFrom);
        filterQInsertTimeTo && (newSearchParams['q-insert-time-to'] = filterQInsertTimeTo);
        filterQShiftId && (newSearchParams['q-shift-id'] = filterQShiftId);
        filterQDeliverTimeId && (newSearchParams['q-deliver-time-id'] = filterQDeliverTimeId);
        filterQCustomerName && (newSearchParams['q-customer-name'] = filterQCustomerName);
        filterQCustomerMobile && (newSearchParams['q-customer-mobile'] = filterQCustomerMobile);
        filterQPostBarcode && (newSearchParams['q-post-barcode'] = filterQPostBarcode);
        filterQReadyTimeFrom && (newSearchParams['q-ready-time-from'] = filterQReadyTimeFrom);
        filterQReadyTimeTo && (newSearchParams['q-ready-time-to'] = filterQReadyTimeTo);
        filterQSendTimeFrom && (newSearchParams['q-send-time-from'] = filterQSendTimeFrom);
        filterQSendTimeTo && (newSearchParams['q-send-time-to'] = filterQSendTimeTo);
        filterQDeliverTimeFrom && (newSearchParams['q-deliver-time-from'] = filterQDeliverTimeFrom);
        filterQDeliverTimeTo && (newSearchParams['q-deliver-time-to'] = filterQDeliverTimeTo);
        filterQRejectTimeFrom && (newSearchParams['q-reject-time-from'] = filterQRejectTimeFrom);
        filterQRejectTimeTo && (newSearchParams['q-reject-time-to'] = filterQRejectTimeTo);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQId, setFilterQId] = useState(allProps['q-id'] || '');
    const [filterQShopCode, setFilterQShopCode] = useState(allProps['q-shop-code'] || '');
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQStateId, setFilterQStateId] = useState(allProps['q-state-id'] || '');
    const [filterQZoneId, setFilterQZoneId] = useState(allProps['q-zone-id'] || '');
    const [filterQPeikId, setFilterQPeikId] = useState(allProps['q-peik-id'] || '');
    const [filterQPaymentMethodId, setFilterQPaymentMethodId] = useState(
        allProps['q-payment-method-id'] || ''
    );
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    const [filterQInsertTimeFrom, setFilterQInsertTimeFrom] = useState(
        allProps['q-insert-time-from'] || ''
    );
    const [filterQInsertTimeTo, setFilterQInsertTimeTo] = useState(
        allProps['q-insert-time-to'] || ''
    );
    const [filterQShiftId, setFilterQShiftId] = useState(allProps['q-shift-id'] || '');
    const [filterQDeliverTimeId, setFilterQDeliverTimeId] = useState(
        allProps['q-deliver-time-id'] || ''
    );
    const [filterQCustomerName, setFilterQCustomerName] = useState(
        allProps['q-customer-name'] || ''
    );
    const [filterQCustomerMobile, setFilterQCustomerMobile] = useState(
        allProps['q-customer-mobile'] || ''
    );
    const [filterQPostBarcode, setFilterQPostBarcode] = useState(allProps['q-post-barcode'] || '');
    const [filterQReadyTimeFrom, setFilterQReadyTimeFrom] = useState(
        allProps['q-ready-time-from'] || ''
    );
    const [filterQReadyTimeTo, setFilterQReadyTimeTo] = useState(allProps['q-ready-time-to'] || '');
    const [filterQSendTimeFrom, setFilterQSendTimeFrom] = useState(
        allProps['q-send-time-from'] || ''
    );
    const [filterQSendTimeTo, setFilterQSendTimeTo] = useState(allProps['q-send-time-to'] || '');
    const [filterQDeliverTimeFrom, setFilterQDeliverTimeFrom] = useState(
        allProps['q-deliver-time-from'] || ''
    );
    const [filterQDeliverTimeTo, setFilterQDeliverTimeTo] = useState(
        allProps['q-deliver-time-to'] || ''
    );
    const [filterQRejectTimeFrom, setFilterQRejectTimeFrom] = useState(
        allProps['q-reject-time-from'] || ''
    );
    const [filterQRejectTimeTo, setFilterQRejectTimeTo] = useState(
        allProps['q-reject-time-to'] || ''
    );
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-peik/table-data', {
            size: tableSize,
            page: tablePage,
            q_id: filterQId,
            q_shop_code: filterQShopCode,
            q_shop_id: filterQShopId,
            q_state_id: filterQStateId,
            q_zone_id: filterQZoneId,
            q_peik_id: filterQPeikId,
            q_payment_method_id: filterQPaymentMethodId,
            q_title: filterQTitle,
            q_insert_time_from: filterQInsertTimeFrom,
            q_insert_time_to: filterQInsertTimeTo,
            q_shift_id: filterQShiftId,
            q_deliver_time_id: filterQDeliverTimeId,
            q_customer_name: filterQCustomerName,
            q_customer_mobile: filterQCustomerMobile,
            q_post_barcode: filterQPostBarcode,
            q_ready_time_from: filterQReadyTimeFrom,
            q_ready_time_to: filterQReadyTimeTo,
            q_send_time_from: filterQSendTimeFrom,
            q_send_time_to: filterQSendTimeTo,
            q_deliver_time_from: filterQDeliverTimeFrom,
            q_deliver_time_to: filterQDeliverTimeTo,
            q_reject_time_from: filterQRejectTimeFrom,
            q_reject_time_to: filterQRejectTimeTo,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp3 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersCopy
                        taroff-orders-id={row.param_id}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp4 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersPeikSetDelivered
                        taroff-orders-id={row.param_id_2}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp5 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersPeikSetRejected
                        taroff-orders-id={row.param_id_3}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp6 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersPeikConfirmOrder
                        taroff-orders-id={row.param_id_4}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp7 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersPeikSetNotAccepted
                        taroff-orders-id={row.param_id_5}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp8 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersPeikSetAccepted
                        taroff-orders-id={row.param_id_6}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp9 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersView
                        taroff-orders-id={row.param_id_7}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp10 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersEdit
                        taroff-orders-id={row.param_id_8}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp11 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersDelete
                        taroff-orders-id={row.param_id_9}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>مدیریت سفارشات پیکی</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        اکسل
                    </Button>
                    <Button onClick={handlecomp2} color={'secondary'}>
                        جستجو
                    </Button>
                </LeftComponents>
            </Row>
            <RightComponents wrap={true}>
                <SearchBox onEnter={applyFilters}
                    label={'شناسه'}
                    value={filterQId}
                    onChange={setFilterQId}
                    width={'120px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'کد رهگیری در فروشگاه'}
                    value={filterQShopCode}
                    onChange={setFilterQShopCode}
                    width={'120px'}
                />
                <MultiSelectBox
                    label={'فروشگاه'}
                    options={formQShopIdOptions}
                    value={filterQShopId}
                    onChange={setFilterQShopId}
                />
                <MultiSelectBox
                    label={'وضعیت'}
                    options={formQStateIdOptions}
                    value={filterQStateId}
                    onChange={setFilterQStateId}
                />
                <MultiSelectBox
                    label={'محدوده'}
                    options={formQZoneIdOptions}
                    value={filterQZoneId}
                    onChange={setFilterQZoneId}
                />
                <MultiSelectBox
                    label={'پیک'}
                    options={formQPeikIdOptions}
                    value={filterQPeikId}
                    onChange={setFilterQPeikId}
                />
                <MultiSelectBox
                    label={'شیوه ی پرداخت'}
                    options={formQPaymentMethodIdOptions}
                    value={filterQPaymentMethodId}
                    onChange={setFilterQPaymentMethodId}
                />
                <SearchBox onEnter={applyFilters}
                    label={'عنوان'}
                    value={filterQTitle}
                    onChange={setFilterQTitle}
                    width={'120px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان درج از'}
                    value={filterQInsertTimeFrom}
                    onChange={setFilterQInsertTimeFrom}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان درج تا'}
                    value={filterQInsertTimeTo}
                    onChange={setFilterQInsertTimeTo}
                    width={'100px'}
                />
                <MultiSelectBox
                    label={'شیفت های پیک تعارف'}
                    options={formQShiftIdOptions}
                    value={filterQShiftId}
                    onChange={setFilterQShiftId}
                />
                <MultiSelectBox
                    label={'زمان ارسال'}
                    options={formQDeliverTimeIdOptions}
                    value={filterQDeliverTimeId}
                    onChange={setFilterQDeliverTimeId}
                />
                <SearchBox onEnter={applyFilters}
                    label={'نام خریدار'}
                    value={filterQCustomerName}
                    onChange={setFilterQCustomerName}
                    width={'120px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'همراه خریدار'}
                    value={filterQCustomerMobile}
                    onChange={setFilterQCustomerMobile}
                    width={'120px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'بارکد پستی'}
                    value={filterQPostBarcode}
                    onChange={setFilterQPostBarcode}
                    width={'120px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان آماده ارسال از'}
                    value={filterQReadyTimeFrom}
                    onChange={setFilterQReadyTimeFrom}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان آماده ارسال تا'}
                    value={filterQReadyTimeTo}
                    onChange={setFilterQReadyTimeTo}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان ارسال از'}
                    value={filterQSendTimeFrom}
                    onChange={setFilterQSendTimeFrom}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان ارسال تا'}
                    value={filterQSendTimeTo}
                    onChange={setFilterQSendTimeTo}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان تحویل از'}
                    value={filterQDeliverTimeFrom}
                    onChange={setFilterQDeliverTimeFrom}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان تحویل تا'}
                    value={filterQDeliverTimeTo}
                    onChange={setFilterQDeliverTimeTo}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان برگشت از'}
                    value={filterQRejectTimeFrom}
                    onChange={setFilterQRejectTimeFrom}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان برگشت تا'}
                    value={filterQRejectTimeTo}
                    onChange={setFilterQRejectTimeTo}
                    width={'100px'}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>ردیف</TableColumn>
                        <TableColumn mobile={false}>عنوان فروشگاه سفارش</TableColumn>
                        <TableColumn mobile={false}>نام خریدار سفارش</TableColumn>
                        <TableColumn mobile={false}>مبلغ سفارش</TableColumn>
                        <TableColumn mobile={false}>عنوان وضعیت سفارش</TableColumn>
                        <TableColumn mobile={false}>زمان درج سفارش</TableColumn>
                        <TableColumn mobile={false}></TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_shop_id_title}</TextView>
                                <RightComponents>
                                    <TextView>{row.text_title}</TextView>
                                    <TextView>{row.text}</TextView>
                                    <TextView>{row.text_shop_code}</TextView>
                                </RightComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView bold={true}>{row.text_customer_name}</TextView>
                                    <TextView bold={true}>{row.text_customer_mobile}</TextView>
                                </RightComponents>
                                <RightComponents>
                                    <TextView>{row.text_address}</TextView>
                                    <TextView>{row.text_2}</TextView>
                                    <TextView>{row.text_deliver_time_id_title}</TextView>
                                    <TextView>{row.text_3}</TextView>
                                    <TextView>{row.text_peik_id_title}</TextView>
                                </RightComponents>
                                <TextView>{row.text_op_time_state}</TextView>
                                <Row>
                                    <RightComponents>
                                        {row.show && (
                                            <Button
                                                onClick={() => handlecomp4(row)}
                                                color={'primary'}
                                                rightIcon={'fal fa-check'}
                                                tooltip={'تغییر وضعیت به تحویل شده'}
                                            >
                                                تحویل شده
                                            </Button>
                                        )}
                                        {row.show_2 && (
                                            <Button
                                                onClick={() => handlecomp5(row)}
                                                color={'warn'}
                                                rightIcon={'fal fa-ban'}
                                                tooltip={'تغییر وضعیت به برگشتی'}
                                            >
                                                برگشتی
                                            </Button>
                                        )}
                                    </RightComponents>
                                    <LeftComponents>
                                        <Button
                                            onClick={() => handlecomp3(row)}
                                            color={'primary'}
                                            rightIcon={'fal fa-copy'}
                                        >
                                            کپی
                                        </Button>
                                    </LeftComponents>
                                </Row>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true} format={'money'}>
                                    {row.text_payable_price}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView backColor={row.color_state_id_color}>
                                    {row.text_state_id_title}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_insert_time}
                                </TextView>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_send_time}
                                </TextView>
                                <TextView>{row.text_deliver_time_id_title_2}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <LeftComponents>
                                    {row.show_3 && (
                                        <Button
                                            onClick={() => handlecomp6(row)}
                                            rightIcon={'far fa-check-double'}
                                            tooltip={'تایید مالی'}
                                        ></Button>
                                    )}
                                    {row.show_4 && (
                                        <Button
                                            onClick={() => handlecomp7(row)}
                                            color={'accent'}
                                            rightIcon={'fal fa-times'}
                                            tooltip={'عدم قبول'}
                                        ></Button>
                                    )}
                                    {row.show_5 && (
                                        <Button
                                            onClick={() => handlecomp8(row)}
                                            color={'accent'}
                                            rightIcon={'fal fa-check'}
                                            tooltip={'تایید'}
                                        ></Button>
                                    )}
                                    <Button
                                        onClick={() => handlecomp9(row)}
                                        rightIcon={'far fa-info'}
                                        tooltip={'Taroff Orders View'}
                                    ></Button>
                                    {row.show_6 && (
                                        <Button
                                            onClick={() => handlecomp10(row)}
                                            rightIcon={'far fa-edit'}
                                            tooltip={'Taroff Orders Edit'}
                                        ></Button>
                                    )}
                                    {row.show_7 && (
                                        <Button
                                            onClick={() => handlecomp11(row)}
                                            color={'warn'}
                                            rightIcon={'far fa-trash'}
                                            tooltip={'Taroff Orders Delete'}
                                        ></Button>
                                    )}
                                </LeftComponents>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
